export const handleSelectChange = (
  e,
  actionType,
  invalidMac,
  setInvalidMac,
  inputData,
  setInputData,
  setMacAddressError,
) => {
  if (
    actionType.action === 'select-option' ||
    actionType.action === 'create-option'
  ) {
    let isMacValid = true;
    if (actionType.action === 'create-option') {
      isMacValid = validateMac(e.value, setInvalidMac, setMacAddressError);
    } else if (actionType.action === 'select-option' && invalidMac) {
      setInvalidMac(false);
    }

    if (isMacValid) {
      let inputMac = e.value.toUpperCase();
      setInputData({ ...inputData, macAddress: inputMac });
    }
  }
};

// Validate mac address field (Goes with handleSelectChange)
const validateMac = (val, setInvalidMac, setMacAddressError) => {
  let currValue = val;
  let format = /^[a-f0-9]*$/i;
  if (currValue.length !== 12 || !format.test(currValue)) {
    setInvalidMac(true);
    setMacAddressError(
      'Invalid! The MAC address must be 12 characters long, containing only numbers and letters (A-F)',
    );
    return false;
  } else {
    setInvalidMac(false);
    return true;
  }
};

export const displayNamesConverter = (readerNames) => {
  const firstKeys = readerNames?.map((device) => Object.values(device)[0]);
  const secondKeys = readerNames?.map((device) => Object.values(device)[1]);
  const optionsArray = [];
  if (firstKeys != null) {
    for (let i = 0; i < firstKeys.length; i++) {
      let entry = firstKeys[i];
      let device_type = secondKeys[i];
      let formattedEntry = {};

      formattedEntry[`device`] = `${device_type}`;
      formattedEntry['value'] = `${entry}`;
      formattedEntry['label'] = `${entry}`;

      optionsArray.push(formattedEntry);
    }
  }
  return optionsArray;
};

export const createHostname = (macAddress, deviceType) => {
  let partialMac = macAddress.substring(6).toUpperCase();
  return new Promise((resolve, reject) => {
    let hostname = deviceType.concat(partialMac);

    hostname.length > 6
      ? resolve(hostname)
      : reject('Error: Unable to create hostname');
  });
};

export const createFQDN = (hostname, locationId) => {
  const hqLocations = 'T9999';
  let domain = '';

  if (hostname && locationId) {
    domain =
      locationId === hqLocations ? '.hq.target.com' : '.stores.target.com';
  }
  return hostname.concat(domain);
};
